
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nm/news/insurance-courtside-club",
      function () {
        return require("private-next-pages/nm/news/insurance-courtside-club.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nm/news/insurance-courtside-club"])
      });
    }
  